<template>
    <article class="product-list-item card">
        <div class="card-body">
            <div :class="paddingClasses" :style="paddingInlineStyles">
                <div class="product-image-wrapper">
                    <slot name="item-image">
                        <a :href="item | itemURL(urlWithVariationId)">
                            <lazy-img
                                picture-class="product-image"
                                :image-url="item.images.all[0].urlSecondPreview"
                                :alt="item.texts.name1"
                                :title="item.texts.name1">
                            </lazy-img>
                        </a>
                    </slot>
                </div>

                <slot name="store-special">
                    <item-store-special v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                                        :store-special="storeSpecial"
                                        :recommended-retail-price="item.prices.rrp"
                                        :variation-retail-price="item.prices.default"
                                        :special-offer-price="item.prices.specialOffer"
                                        :decimal-count="decimalCount"
                                        :bundle-type="item.variation.bundleType"
                                        :item-type="item.item.itemType">
                    </item-store-special>
                </slot>


                <!-- ITEM DETAILS -->
                <slot name="item-details">
                    <div class="product-info">
                        <a :href="item | itemURL(urlWithVariationId)" class="product-name">
                            {{ item | itemName }}<!--
                        --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                        </a>

                        <slot name="before-prices"></slot>

                        <div class="product-price" :class="{'product-price--sale': item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value}">
                            <template v-if="item.item.itemType === 'set'">
                                {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}{{ $translate("Ceres::Template.itemFootnote") }}
                            </template>
                                <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                                    {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }}{{ $translate("Ceres::Template.itemFootnote") }}
                            </template>
                            <template v-else>
                                {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}{{ $translate("Ceres::Template.itemFootnote") }}
                            </template>

                            <template v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value">
                                <span class="product-price--uvp" v-if="item.prices.specialOffer">
                                    {{ $translate('DiaWolfMoebel::Template.uvp') }} {{ item.prices.default.unitPrice.formatted}}
                                </span>
                                <span class="product-price--uvp" v-else>
                                    {{ $translate('DiaWolfMoebel::Template.uvp') }} {{ item.prices.rrp.unitPrice.formatted }}
                                </span>
                            </template>

                        </div>


                        <slot name="after-prices"></slot>

                        <!-- <div class="product-price--vat">
                            * <span v-if="showNetPrices">{{ $translate("Ceres::Template.itemExclVAT") }}</span>
                            <span v-else>{{ $translate("Ceres::Template.itemInclVAT") }}</span>
                            {{ $translate("Ceres::Template.itemExclusive") }}
                            <a v-if="$ceres.config.global.shippingCostsCategoryId > 0" data-toggle="modal" href="#shippingscosts" class="text-appearance" :title="$translate('Ceres::Template.itemShippingCosts')">{{ $translate("Ceres::Template.itemShippingCosts") }}</a>
                            <a v-else :title="$translate('Ceres::Template.itemShippingCosts')">{{ $translate("Ceres::Template.itemShippingCosts") }}</a>
                        </div> -->
                    </div>
                    <div class="product-add-to-basket">
                        <add-to-basket
							data-testing="item-add-to-basket"
							:variation-id="item.variation.id"
                            :is-salable="!!item.filter && item.filter.isSalable"
                            :has-children="!!item.item && item.item.salableVariationCount > 1"
                            :interval-quantity="item.variation.intervalOrderQuantity || 1"
                            :minimum-quantity="item.variation.minimumOrderQuantity"
                            :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                            :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                            :has-order-properties="item.hasOrderProperties"
							:has-required-order-property="item.hasRequiredOrderProperty"
							:use-large-scale="false"
                            :show-quantity="false"
                            :item-url="item | itemURL(urlWithVariationId)"
                            :has-price="item | hasItemDefaultPrice"
							:has-graduated-price="itemGraduatedPriceisCheapestSorting || itemGraduatedPricesalableVariationCount"
							:item-type="item.item.itemType">
                        </add-to-basket>
                    </div>
                </slot>
                <!-- ./ITEM DETAILS  -->
            </div>
        </div>
    </article>
</template>

<script>
import { mapState } from "vuex";
import ItemStoreSpecial from "~/app/components/itemList/ItemStoreSpecial.vue";
import {getSlotData} from "ceres/app/helper/getSlotData";

export default {
    components: {
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlMiddle"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
		forceUrlWithVariationId:
		{
			type: Boolean,
			default: false
		}
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
    {
        item()
        {
			return this.itemData || this.itemSlotData || this.itemDataRef;
        },

		itemSlotData: getSlotData('item-data'),


		/**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

		basePrice()
		{
			return this.item.prices.default.basePrice;
		},

		itemPriceGraduated()
		{
			let unitPrice;
			if (App.config.item.enableGraduatedPrices) {
				unitPrice = this.item.prices.graduatedPrices.length > 0
					? this.item.prices.graduatedPrices[0].unitPrice
					: this.item.prices.default.unitPrice;
			} else {
				unitPrice = this.item.prices.default.unitPrice;
			}

			return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
		},

		itemGraduatedPriceisCheapestSorting()
		{
			return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
		},

		itemGraduatedPricesalableVariationCount()
		{
			return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
		},


		itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0;
        },

		hasCrossPrice() {
			const hasRrpPrice = !!this.item.prices.rrp &&
				this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

			const hasBeforePrice = !!this.item.prices.specialOffer &&
				!!this.item.prices.default &&
				this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

			return hasRrpPrice || hasBeforePrice;
		},

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices
        })
    }
}
</script>
